import axios from "axios";
import endpoints from "@/api/endpoints";
import { createWishlistData } from "./utils/createWishlistData";
import { createWishlistItemData } from "./utils/createWishlistItemData";

export class WishlistService {
  static __instance = null;

  constructor() {
    if (WishlistService.__instance) {
      return WishlistService.__instance;
    }

    WishlistService.__instance = this;
  }

  getAllWishlists() {
    return axios.get(endpoints.wishlist.list).then(response => {
      if (response.data) {
        return response.data;
      }
      throw new Error();
    });
  }

  addWishlist({ companyId, title, description }) {
    const wishlist = createWishlistData({ companyId, title, description });

    return axios.post(endpoints.wishlist.addList, wishlist).then(response => {
      if (response.data.success) {
        return response.data.wishlist;
      }
      throw new Error();
    });
  }

  removeWishlist(id) {
    const data = new FormData();
    data.append("id", id);

    return axios.post(endpoints.wishlist.removeList, data).then(response => {
      if (response.data.success) {
        return;
      }
      throw new Error();
    });
  }

  updateWishlist({ id, title, description }) {
    const data = new FormData();
    data.append("id", id);
    data.append("title", title);
    data.append("description", description);

    return axios.post(endpoints.wishlist.updateList, data).then(response => {
      if (response.data.success) {
        return;
      }
      throw new Error();
    });
  }

  addItemToWishlist({ companyId, itemId, wishlistId }) {
    const item = createWishlistItemData({ companyId, itemId, wishlistId });

    return axios.post(endpoints.wishlist.addItem, item).then(response => {
      if (response.data.success) {
        return response.data.wishlistItem;
      }
      throw new Error();
    });
  }

  moveItemToWishlist(listFromId, listToId, itemId) {
    const data = new FormData();
    data.append("listFromId", listFromId);
    data.append("listToId", listToId);
    data.append("itemId", itemId);

    return axios
      .post(endpoints.wishlist.moveItemToList, data)
      .then(response => {
        if (response.data.success) {
          return;
        }
        throw new Error();
      });
  }

  addCartToWishlist(companyId) {
    const data = new FormData();
    data.append("companyId", companyId);

    return axios.post(endpoints.wishlist.addBasket, data).then(response => {
      if (response.data.success) {
        return;
      }
      throw new Error();
    });
  }

  removeItemFromWishlist(wishlistID, itemID) {
    const data = new FormData();
    data.append("wishListID", wishlistID);
    data.append("itemID", itemID);

    return axios.post(endpoints.wishlist.removeItem, data).then(response => {
      if (response.data.success) {
        return;
      }
      throw new Error();
    });
  }
}

export const wishlistService = new WishlistService();
